import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { pushTryOnInStoreEvent } from "../../../../../../data-layer/data-layer/try-on-in-store.js";
/* empty css            */
const Footer = ({ skus }) => {
  const { getLabel } = useIntl();
  const { href } = useLink({ route: "appointments.book", params: { tryInStoreFlow: "1" } }) || {};
  const onHandleClick = () => {
    pushTryOnInStoreEvent({
      interactionType: "book_appointment",
      items: skus
    });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "try-in-store-selection-modal__footer-wrapper" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "solid",
      caption: getLabel("tryInStore.component.selectionModal.bookAppointmentButton"),
      href,
      onClick: onHandleClick
    }
  ));
};
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
